import { FolderIdentification } from './folder-identification';

export class FolderAddNotification {
    public folderIdentification: FolderIdentification;
    public viewId: number;

    public static fromJson(other: any): FolderAddNotification {
        const instance = new FolderAddNotification();
        instance.viewId = other.ViewId;
        instance.folderIdentification = other.FolderIdentification;
        return instance;
    }
}
